import React from 'react';
import { StyledSvgIcon } from '../icon.styles';
import { customIconsPropTypes } from './customicons.propTypes';

const UmbrellaIcon = ({ fontSize, color, sx, title }) => (
  <StyledSvgIcon
    fontSize={fontSize}
    color={color}
    titleAccess={title}
    data-testid={title}
    aria-label={title}
    sx={sx}
  >
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.72628 18.6223C5.1531 18.6223 5.45182 18.3091 5.69407 17.9393C6.49064 16.7299 7.4305 15.9752 8.83907 15.9752C10.2616 15.9752 11.0873 16.7159 11.7843 17.9247C12.012 18.3236 12.2682 18.6223 12.695 18.6223C13.1219 18.6223 13.3926 18.3236 13.6057 17.9393C14.0757 17.0996 14.8868 16.4306 15.7975 16.1033V28.1423C15.7975 29.2522 15.0143 30.1198 13.8195 30.1198C12.6525 30.1198 11.8699 29.2376 11.8699 28.1423C11.8699 27.2741 11.3296 26.7763 10.6459 26.7763C9.97746 26.7763 9.46503 27.2741 9.46503 28.1423C9.46503 30.5752 11.315 32.5107 13.8195 32.5107C16.3379 32.5107 18.2018 30.5752 18.2018 28.1423V16.1033C19.1241 16.4412 19.8993 17.0906 20.3936 17.9393C20.6067 18.3236 20.8629 18.6223 21.3043 18.6223C21.7311 18.6223 21.9874 18.3236 22.215 17.9247C22.912 16.7299 23.7377 15.9758 25.1603 15.9758C26.5689 15.9758 27.5227 16.7153 28.3053 17.9393C28.5469 18.3097 28.8456 18.6223 29.2731 18.6223C29.8559 18.6223 30.4115 18.1524 30.4115 17.3838C30.4115 12.3044 26.5695 5.26035 18.2018 4.63378V2.75649C18.2018 2.00242 17.69 1.48999 16.9924 1.48999C16.3094 1.48999 15.7975 2.00242 15.7975 2.75649V4.63499C7.42989 5.26095 3.58789 12.305 3.58789 17.385C3.58789 18.153 4.12825 18.6223 4.72628 18.6223ZM21.0766 15.9479C20.237 14.7093 18.6857 13.8132 16.9924 13.8132C15.3136 13.8132 13.7624 14.7099 12.9227 15.9479C12.8517 16.0614 12.8231 16.1039 12.7521 16.1039C12.695 16.1039 12.638 16.0614 12.5815 15.9479C11.7843 14.5247 10.4607 13.8842 9.12321 13.8842C7.70068 13.8842 6.53375 14.6243 5.85071 15.5921C6.60478 11.9067 10.2331 6.78367 16.9924 6.78367C23.7663 6.78367 27.3946 11.9061 28.1486 15.5921C27.4656 14.6243 26.2987 13.8842 24.8761 13.8842C23.5386 13.8842 22.2005 14.5247 21.4179 15.9479C21.3468 16.0614 21.3043 16.1039 21.2479 16.1039C21.1762 16.1039 21.1477 16.0614 21.0766 15.9479Z"
        fill="currentColor"
      />
    </svg>
  </StyledSvgIcon>
);
export default UmbrellaIcon;

UmbrellaIcon.propTypes = customIconsPropTypes;
